module.exports = __webpack_public_path__ + "img/fastcharger-disabled-private.8c36fe09.png";